export const ALL_SALES_ORDER_REQUEST = "ALL_SALES_ORDER_REQUEST";
export const ALL_SALES_ORDER_SUCCESS = "ALL_SALES_ORDER_SUCCESS";
export const ALL_SALES_ORDER_FAIL = "ALL_SALES_ORDER_FAIL";